"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var cartesian_rectangle_1 = require("@rocketfarm/cartesian-rectangle");
var basic_1 = require("./basic");
var PinwheelError = /** @class */ (function (_super) {
    __extends(PinwheelError, _super);
    function PinwheelError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PinwheelError;
}(Error));
exports.PinwheelError = PinwheelError;
/**
 * Transform @rotatedRectangleLocation to coorinatesystem located relatively to current coorinate system.
 * @param rectangleLocation
 * @param relativeLocation Location of new coordinate system relative to current
 */
function createRelativeLocation(rectangleLocation, relativeLocation) {
    return cartesian_rectangle_1.copyToLocation(rectangleLocation, relativeLocation.getX() + rectangleLocation.getXMin(), relativeLocation.getY() + rectangleLocation.getYMin());
}
/**
 * Shrinking @rotatedRectangleLocation, subtracting @padding from alle four sides. @pinwheel helper function.
 * @param rectangleLocation Rectangle to shring
 * @param padding Padding amount
 */
function subtractPaddingToRotatedRectangleLocation(rectangleLocation, padding) {
    if (padding >= rectangleLocation.getWidth()) {
        throw new PinwheelError("Can not apply a padding of " + padding + " to RotatedRectangleLocation with width " + rectangleLocation.getWidth());
    }
    return new cartesian_rectangle_1.RectangleLocation(rectangleLocation.getRectangleWidth() - padding, rectangleLocation.getRectangleLength() - padding, rectangleLocation.getXMin() + padding, rectangleLocation.getYMin() + padding, rectangleLocation.isRotated());
}
/**
 * Move origo for @param rectangleLocation. Throws @UtilError if @param rectangleLocation ends up in negative area of the coordinate system
 * @param rectangleLocation RotatedRectangleLocation to modify
 * @param x movement of origo
 * @param y movement of origo
 */
function moveOrigo(rectangleLocation, x, y) {
    var xMin = rectangleLocation.getXMin();
    var yMin = rectangleLocation.getYMin();
    if (x > xMin || y > yMin) {
        throw new PinwheelError("Can not trim frame. Trim slice overlaps one or more RotatedRectangleLocation in rotatedRectangleLocation parameter ");
    }
    else {
        return cartesian_rectangle_1.copyToLocation(rectangleLocation, rectangleLocation.getXMin() - Math.abs(x), rectangleLocation.getYMin() - Math.abs(y));
    }
}
exports.moveOrigo = moveOrigo;
/**
 * Abstract helper function for step two through five.
 * Extending two FigureGroups in constom direction as long as geometric condition between the figure groups are not met.
 * Basically we make sure extensions described below do now collide/overlap with existing figures/extensions.
 * @param opposed @T blocking the expansion direction of @parma main .
 * @param twin This figure group is positioned diagonally relative to @main.
 * The expansion direction is oposite of @param main expansion direction.
 * The expansion direction of @twin should be defined as oposite of @main.
 * The number of expansion steps is equal to the number of expansion steps for main.
 * For this reason, only the number of @main expansion steps are calculated.
 * @param main The expansion direction of this groups should be oposite of @twin expansion group.
 * This group is diagonaly placed relative to @twin group.
 * Each expansion step is applied only if next extension step does not overlap with either @twin expansion step, or @opposed.
 * Have a look at the ASCII illustrations of each step, two trough five of the pinwheel implementation.
 * Her you will find an example illustration and usage of this abstract helper funcion.
 * @param extensionSelector @Function to select and return extension for both @main,
 * and @twin, mainExtension, and twinExtension respectively.
 * Extensions are added to their respective groups for as long as colliding/overlapping conditions described above are not met.
 * The main edge adjacent to the extenstion must also be returned
 */
function extendFigureGroupWhile(opposed, twin, main, extensionSelector) {
    while (true) {
        var _a = extensionSelector(main, twin), mainExtension = _a.mainExtension, twinExtension = _a.twinExtension, mainEdge = _a.mainEdge;
        // Checking for overlaps/collisions
        if (!cartesian_rectangle_1.hasOverlapInLists(mainExtension.concat(mainEdge), twinExtension) &&
            !cartesian_rectangle_1.hasOverlapInLists(mainExtension, [opposed])) {
            main.addFigures(mainExtension);
            twin.addFigures(twinExtension);
        }
        else {
            return;
        }
    }
}
/**
 * Packing boxes within the frame in a pinwheel pattern.
 * @param frameWidth Width of bouding rectangle
 * @param frameLength Length of bounding rectangle
 * @param boxWidth Width of box to fit withing the frame
 * @param boxLength Length of box to fit withing the frame
 * @param conterclockwise Optionsla flag for running the counter clockwise version of the Pinwheel algorithm. Default value is false
 * @param flipXAxis Optional switch for flipping pattern round the x-axis
 * @param padding Optional padding around box, default is 0
 */
function pinwheel(frameWidth, frameLength, boxWidth, boxLength, conterclockwise, flipXAxis, padding) {
    if (conterclockwise === void 0) { conterclockwise = false; }
    if (flipXAxis === void 0) { flipXAxis = false; }
    if (padding === void 0) { padding = 0; }
    if (padding > 0) {
        return pinwheel(frameWidth + padding, frameLength + padding, boxWidth + padding, boxLength + padding, conterclockwise, flipXAxis).map(function (rrl) { return moveOrigo(subtractPaddingToRotatedRectangleLocation(rrl, padding), padding, padding); });
    }
    // If counter flipXAxis is set,  we can call our selves clockwise and flip x-axis on result
    if (flipXAxis) {
        return pinwheel(frameWidth, frameLength, boxWidth, boxLength, conterclockwise, false, padding).map(function (rrl) {
            return new cartesian_rectangle_1.RectangleLocation(rrl.getRectangleWidth(), rrl.getRectangleLength(), frameWidth - rrl.getXMin() - rrl.getWidth(), rrl.getYMin(), rrl.isRotated());
        });
    }
    // Init one vertically oriented rectangle, and one horizontally orientet rectangle
    // for easy reference
    var rectangleV = new cartesian_rectangle_1.RectangleLocation(boxWidth, boxLength, 0, 0, true);
    var rectangleH = new cartesian_rectangle_1.RectangleLocation(boxWidth, boxLength, 0, 0, false);
    var box = new cartesian_rectangle_1.Rectangle(boxWidth, boxLength);
    /* First step. Init a FigureGroup<RectangleLocation> with in each corner on the pallet.
     *  A certical boxe in top right corner and bottom left corner
     *  A horizontal box in top left corner and bottom right corner
     *  If boxes overlap. This function will throw an error
     *
     *  ##############________________#########
     *  ##############________________#########
     *  ##############________________#########
     *  ##############________________#########
     *  ##############________________#########
     *  ______________________________#########
     *  ______________________________#########
     *  _______________________________________
     *  _______________________________________
     *  _______________________________________
     *  _______________________________________
     *  _______________________________________
     *  _______________________________________
     *  _______________________________________
     *  _______________________________________
     *  #########______________________________
     *  #########______________________________
     *  #########________________##############
     *  #########________________##############
     *  #########________________##############
     *  #########________________##############
     */
    var topLeftGroup = new cartesian_rectangle_1.Group([
        cartesian_rectangle_1.copyToLocation(rectangleH, 0, frameLength - rectangleH.getLength())
    ]);
    var topRightGroup = new cartesian_rectangle_1.Group([cartesian_rectangle_1.copyToLocation(rectangleV, frameWidth - boxLength, frameLength - boxWidth)
    ]);
    var bottomLeftGroup = new cartesian_rectangle_1.Group([
        cartesian_rectangle_1.copyToLocation(rectangleV, 0, 0)
    ]);
    var bottomRightGroup = new cartesian_rectangle_1.Group([
        cartesian_rectangle_1.copyToLocation(rectangleH, frameWidth - rectangleH.getWidth(), 0)
    ]);
    topLeftGroup.getYMin();
    // Check if corners overlap. If there is an overlap we cannot complete this algorithm, and we return an empty array
    if (cartesian_rectangle_1.overlapExits(topLeftGroup
        .getFigures()
        .concat(topRightGroup.getFigures())
        .concat(bottomLeftGroup.getFigures())
        .concat(bottomRightGroup.getFigures()))) {
        return [];
    }
    /* Second colockwise step, Extend bottom left corner and top right corner vertically
     *
     *  ##############________________#########
     *  ##############________________#########
     *  ##############________________#########
     *  ##############________________#########
     *  ##############________________#########
     *  ______________________________#########
     *  ______________________________#########
     *  ______________________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########______________________________
     *  #########______________________________
     *  #########______________________________
     *  #########________________##############
     *  #########________________##############
     *  #########________________##############
     *  #########________________##############
     *  #########________________##############
     */
    conterclockwise
        ? extendFigureGroupWhile(bottomRightGroup.getBottomLeftFigure(), topRightGroup, bottomLeftGroup, function (main, twin) {
            return {
                mainExtension: main.getRightExtension(),
                mainEdge: main.getRightFigures(),
                twinExtension: twin.getLeftExtension(),
            };
        })
        : extendFigureGroupWhile(topLeftGroup.getBottomLeftFigure(), topRightGroup, bottomLeftGroup, function (main, twin) {
            return {
                mainExtension: main.getTopExtension(),
                mainEdge: main.getTopFigures(),
                twinExtension: twin.getBottomExtension(),
            };
        });
    /* Third colockwise step, extend top left corner and bottom right corner horizontally
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  ______________________________#########
     *  ______________________________#########
     *  ______________________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########______________________________
     *  #########______________________________
     *  #########______________________________
     *  #########__############################
     *  #########__############################
     *  #########__############################
     *  #########__############################
     *  #########__############################
     */
    conterclockwise
        ? extendFigureGroupWhile(bottomLeftGroup.getTopLeftFigure(), bottomRightGroup, topLeftGroup, function (main, twin) {
            return {
                mainExtension: main.getBottomExtension(),
                mainEdge: main.getBottomFigures(),
                twinExtension: twin.getTopExtension(),
            };
        })
        : extendFigureGroupWhile(topRightGroup.getTopLeftFigure(), bottomRightGroup, topLeftGroup, function (main, twin) {
            return {
                mainExtension: main.getRightExtension(),
                mainEdge: main.getRightFigures(),
                twinExtension: twin.getLeftExtension(),
            };
        });
    /* Forth colockwise step, try to widen vertical ledges
     *  #####################,,,,,,,,,#########
     *  #####################,,,,,,,,,#########
     *  #####################,,,,,,,,,#########
     *  #####################,,,,,,,,,#########
     *  #####################,,,,,,,,,#########
     *  _____________________,,,,,,,,,#########
     *  _____________________,,,,,,,,,#########
     *  _____________________,,,,,,,,,#########
     *  #########,,,,.,,,,___,,,, ,,,,#########
     *  #########,,,,,,,,,___,,,,,,,,,#########
     *  #########,,,,,,,,,___,,,,,,,,,#########
     *  #########,,,,,,,,,___,,,,,,,,,#########
     *  #########,,,,,,,,,___,,,,,,,,,#########
     *  #########,,,,,,,,,___,,,,,,,,,#########
     *  #########,,,,,,,,,_____________________
     *  #########,,,,.,,,,_____________________
     *  #########,,,,,,,,,_____________________
     *  #########,,,,,,,,,#####################
     *  #########,,,,,,,,,#####################
     *  #########,,,,,,,,,#####################
     *  #########,,,,,,,,,#####################
     */
    conterclockwise
        ? extendFigureGroupWhile(bottomRightGroup.getTopRightFigure(), bottomLeftGroup, topRightGroup, function (main, twin) {
            return {
                mainExtension: main.getBottomExtension(),
                mainEdge: main.getBottomFigures(),
                twinExtension: twin.getTopExtension(),
            };
        })
        : extendFigureGroupWhile(bottomRightGroup.getBottomLeftFigure(), topRightGroup, bottomLeftGroup, function (main, twin) {
            return {
                mainExtension: main.getRightExtension(),
                mainEdge: main.getRightExtension(),
                twinExtension: twin.getLeftExtension(),
            };
        });
    /* Fifth colockwise step, try to widen horizontal ledges
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  ,,,,,,,,,,,,,,,,,,,,,,,,,,,,__#########
     *  ,,,,,,,,,,,,,,,,,,,,,,,,,,,,__#########
     *  ,,,,,,,,,,,,,,,,,,,,,,,,,,,,__#########
     *  ,,,,,,,,,,,,,,,,,,,,,,,,,,,,__#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########_____________________#########
     *  #########__,,,,,,,,,,,,,,,,,,,,,,,,,,,,
     *  #########__,,,,,,,,,,,,,,,,,,,,,,,,,,,,
     *  #########__,,,,,,,,,,,,,,,,,,,,,,,,,,,,
     *  #########__,,,,,,,,,,,,,,,,,,,,,,,,,,,,
     *  #########__############################
     *  #########__############################
     *  #########__############################
     *  #########__############################
     *  #########__############################
     */
    conterclockwise
        ? extendFigureGroupWhile(bottomLeftGroup.getBottomRightFigure(), topLeftGroup, bottomRightGroup, function (main, twin) {
            return {
                mainExtension: main.getLeftExtension(),
                mainEdge: main.getLeftFigures(),
                twinExtension: twin.getRightExtension(),
            };
        })
        : extendFigureGroupWhile(bottomLeftGroup.getTopLeftFigure(), bottomRightGroup, topLeftGroup, function (main, twin) {
            return {
                mainExtension: main.getBottomExtension(),
                mainEdge: main.getBottomFigures(),
                twinExtension: twin.getTopExtension(),
            };
        });
    /* Sixth step, if center area can contain a box fill this area with the best[1] alterantive among these algorithms:
     *  1. Recursive pinwheel call
     *  2. BasicRows algorithm
     *  3. BasicColumns algoritm
     *
     *  [1] Best alternative contains the higest number of boxes
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  ############################__#########
     *  _________,,,,,,,,,,,,,,,,,,,,,#########
     *  _________,,,,,,,,,,,,,,,,,,,,,#########
     *  _________,,,,,,,,,,,,,,,,,,,,,#########
     *  #########,,,,,,,,,,,,,,,,,,,,,#########
     *  #########,,,,,,,,,,,,,,,,,,,,,#########
     *  #########,,,,,,,,,,,,,,,,,,,,,#########
     *  #########,,,,,,,,,,,,,,,,,,,,,#########
     *  #########,,,,,,,,,,,,,,,,,,,,,#########
     *  #########,,,,,,,,,,,,,,,,,,,,,#########
     *  #########,,,,,,,,,,,,,,,,,,,,,_________
     *  #########,,,,,,,,,,,,,,,,,,,,,_________
     *  #########,,,,,,,,,,,,,,,,,,,,,_________
     *  #########__############################
     *  #########__############################
     *  #########__############################
     *  #########__############################
     */
    var xMin = conterclockwise ? topLeftGroup.getXMax() : bottomLeftGroup.getXMax();
    var xMax = conterclockwise ? bottomRightGroup.getXMin() : topRightGroup.getXMin();
    var yMin = conterclockwise ? bottomLeftGroup.getYMax() : bottomRightGroup.getYMax();
    var yMax = conterclockwise ? topRightGroup.getYMin() : topLeftGroup.getYMin();
    var subFrameWidth = yMax - yMin - 1;
    var subFrameLength = xMax - xMin - 1;
    var subFrame = new cartesian_rectangle_1.Rectangle(subFrameWidth, subFrameLength);
    var xMinSubframe = xMin + 1;
    var yMinSubframe = yMin + 1;
    var palletIsFull = !subFrame.canContainRectangle(boxWidth, boxLength);
    if (palletIsFull) {
        return topLeftGroup
            .getFigures()
            .concat(topRightGroup.getFigures())
            .concat(bottomLeftGroup.getFigures())
            .concat(bottomRightGroup.getFigures());
    }
    else {
        var canDoSubPinwheel = canDoPinwheel(subFrameWidth, subFrameLength, boxWidth, boxLength);
        var bestSubframe = void 0;
        var basicRowsResult = basic_1.basicRows(subFrameWidth, subFrameLength, boxWidth, boxLength, padding).map(function (r) {
            return createRelativeLocation(r, new cartesian_rectangle_1.Location(xMinSubframe, yMinSubframe));
        });
        var basicColumnsResult = basic_1.basicColumns(subFrameWidth, subFrameLength, boxWidth, boxLength, padding).map(function (r) {
            return createRelativeLocation(r, new cartesian_rectangle_1.Location(xMinSubframe, yMinSubframe));
        });
        var bestBasic = basicRowsResult.length > basicRowsResult.length ? basicRowsResult : basicColumnsResult;
        if (canDoSubPinwheel) {
            var subPinwheel = pinwheel(subFrameWidth, subFrameLength, boxWidth, boxLength, conterclockwise, flipXAxis, padding).map(function (rl) {
                return createRelativeLocation(rl, new cartesian_rectangle_1.Location(xMinSubframe, yMinSubframe));
            });
            bestSubframe = subPinwheel.length > bestBasic.length ? subPinwheel : bestBasic;
        }
        else {
            bestSubframe = bestBasic;
        }
        return topLeftGroup
            .getFigures()
            .concat(topRightGroup.getFigures())
            .concat(bottomLeftGroup.getFigures())
            .concat(bottomRightGroup.getFigures())
            .concat(bestSubframe);
    }
}
exports.pinwheel = pinwheel;
function canDoPinwheel(frameWidth, frameLength, boxWidth, boxLength) {
    var minSubframeDimension = boxWidth + boxLength;
    return frameWidth >= minSubframeDimension && frameLength >= minSubframeDimension;
}
exports.canDoPinwheel = canDoPinwheel;
